/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FareSubtype {
    TypeC = 'TypeC',
    TypeL = 'TypeL'
}

export function FareSubtypeFromJSON(json: any): FareSubtype {
    return FareSubtypeFromJSONTyped(json, false);
}

export function FareSubtypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareSubtype {
    return json as FareSubtype;
}

export function FareSubtypeToJSON(value?: FareSubtype | null): any {
    return value as any;
}

